import axios from 'axios'

export default defineNuxtPlugin(() => {
  const RuntimeConfig = useRuntimeConfig()
  const MAIN_API_SERVER = RuntimeConfig.public.MAIN_API
  const GAME_KEY = RuntimeConfig.public.GAME_KEY
  const GAME_VALUE = RuntimeConfig.public.GAME_VALUE

  const mainApi = axios.create({
    baseURL: MAIN_API_SERVER,
    timeout: 30000,
  })

  const authApi = axios.create({
    baseURL: MAIN_API_SERVER,
    timeout: 30000,
  })

  authApi.interceptors.request.use(
    (config) => {
      config.headers?.set(GAME_KEY, GAME_VALUE)

      return config
    },
    (error) => Promise.reject(error),
  )

  mainApi.interceptors.request.use(
    (config) => {
      const authStore = useAuthStore()

      if (authStore.accessToken) {
        config.headers?.set('Authorization', `Bearer ${authStore.accessToken}`)
      }

      config.headers?.set(GAME_KEY, GAME_VALUE)

      return config
    },
    (error) => Promise.reject(error),
  )

  mainApi.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const status = error.response ? error.response.status : null

      if (status !== 401) {
        return Promise.reject(error)
      }
      const RuntimeConfig = useRuntimeConfig()
      // pinia store
      const authStore = useAuthStore()
      const refreshToken = localStorage.getItem(
        `taline-mini-game-${RuntimeConfig.public.GAME_VALUE}-refresh-token`,
      )

      if (refreshToken) {
        try {
          // refresh token

          const result = await authApi.post('/auth/refresh-token', {
            refreshToken,
          })

          const { accessToken } = result.data

          authStore.setAccessToken(accessToken)

          error.response.config.headers.Authorization = `Bearer ${accessToken}`

          return mainApi(error.response.config)
        } catch (authError) {
          // logout
          // authStore.logout()
          if (authError.status === 400) {
            localStorage.removeItem(
              `taline-mini-game-${RuntimeConfig.public.GAME_VALUE}-refresh-token`,
            )
            authStore.refreshToken = ''
            window.location.reload()
          }
          return Promise.reject(authError)
        }
      }
    },
  )

  return {
    provide: {
      mainApi,
    },
  }
})
